import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { TravelBotChatSingleDialogGeneric } from '../../TravelBotChatSingleDialogGeneric';
import analytics from '../../analytics/analytics';
const defaultFallBackComponent = displayedMessage => React.createElement(TravelBotChatSingleDialogGeneric, {
  message: {
    role: 'assistant',
    content: displayedMessage
  }
});
/**
 * ChatMessageErrorBoundary - Error boundary for chat messages
 * @internal
 */
const ChatMessageErrorBoundary = ({
  displayedMessage = '',
  children,
  FallbackComponent,
  compnentName
}) => {
  const handleErrorLogging = function (error, info) {
    analytics.logError(Object.assign({
      compnentName,
      message: 'ChatMessageErrorBoundary',
      errorMessage: error === null || error === void 0 ? void 0 : error.message
    }, info));
  };
  const Fallback = function () {
    return FallbackComponent ? FallbackComponent : defaultFallBackComponent(displayedMessage);
  };
  return React.createElement(ErrorBoundary, {
    FallbackComponent: Fallback,
    onError: handleErrorLogging
  }, children);
};
export default ChatMessageErrorBoundary;